import React from 'react';
import OrderFilePanel from './OrderFilePanel';
import { ordersApi } from '../services/api';

/**
 * Manufacturing Order Form panel — Order Detail (internal side).
 * PDF or Excel; blocks the factory from seeing pending-acceptance orders
 * until uploaded.
 */
export default function ManufacturingFormCard({ order, onChanged }) {
  const hasFactory = !!order?.factory_id;
  const gateRelevant = hasFactory && (order?.pieces_to_factory || 0) > 0;
  if (!gateRelevant && !order?.manufacturing_form) return null;

  return (
    <OrderFilePanel
      order={order}
      fieldKey="manufacturing_form"
      label="Manufacturing Order Form"
      allowedExts={['pdf', 'xls', 'xlsx', 'xlsm']}
      acceptAttr=".pdf,.xls,.xlsx,.xlsm,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      description="Upload the Manufacturing Order Form (PDF or Excel) so the factory can review the brief before accepting this order. The order will NOT appear on the factory portal until this form is uploaded."
      uploadFn={ordersApi.uploadManufacturingForm}
      deleteFn={ordersApi.deleteManufacturingForm}
      downloadUrlFn={ordersApi.getManufacturingFormUrl}
      onChanged={onChanged}
    />
  );
}
